const initialState = {
  screen: 'Index',
  language: 'Croatian'
}

const rootReducer = (state = initialState, action) => {
  let newState
  switch (action.type) {
    case 'UPDATE_SCREEN':
      newState = Object.assign({}, state, { screen: action.payload })
      return newState
    case 'UPDATE_LANGUAGE':
      newState = Object.assign({}, state, { language: action.payload })
      return newState
    default:
      return state;
  }
};
export default rootReducer;


// WEBPACK FOOTER //
// ./src/reduxStore/rootReducer.js